/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page

        // jQuery for page scrolling feature - requires jQuery Easing plugin
        $('a.page-scroll').bind('click', function(event) {
            var $anchor = $(this);
            $('html, body').stop().animate({
                scrollTop: ($($anchor.attr('href')).offset().top - 50)
            }, 1250, 'easeInOutExpo');
            event.preventDefault();
        });

        // Highlight the top nav as scrolling occurs
        $('body').scrollspy({
            target: '.navbar-fixed-top',
            offset: 51
        });

        // Closes the Responsive Menu on Menu Item Click
        $('.navbar-collapse ul li a').click(function() {
            $('.navbar-toggle:visible').click();
        });

        // Offset for Main Navigation
        $('#mainNav').affix({
            offset: {
                top: 100
            }
        });

        $('#mainNav').on('affix.bs.affix', function () {
          $('.brand').removeClass('sr-only');
        });

        $('#mainNav').on('affixed-top.bs.affix', function () {
          $('.brand').addClass('sr-only');
        });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    'contact': {
      init: function() {
        // JavaScript to be fired on all pages
        jQuery('#messageform').hide();
      },
      finalize: function() {
        // Form
        jQuery(document).on('click', '#submit', function(e){
          e.preventDefault();

          // var fd = new FormData();
          var fd = {};
          // var file = jQuery(document).find('input[type="file"]');
          var lastname = jQuery('#myform').find('input[name=lastname]');
          var firstname = jQuery('#myform').find('input[name=firstname]');
          var email = jQuery('#myform').find('input[name=email]');
          var phone = jQuery('#myform').find('input[name=phone]');
          var message = jQuery('#myform').find('textarea[name=message]');

          // var individual_file = file[0].files[0];
          // fd.append("file", individual_file);

          var individual_lastname = lastname.val();
          var individual_firstname = firstname.val();
          var individual_email = email.val();
          var individual_phone = phone.val();
          var individual_message = message.val();

          if ( individual_lastname
            && individual_firstname
            && individual_email
            && individual_message
            && individual_phone ) {

            fd.lastname = individual_lastname;
            fd.firstname = individual_firstname;
            fd.email = individual_email;
            fd.phone = individual_phone;
            fd.message = individual_message;
            fd.action = 'fiu_upload_file';
            console.log(fd);

            jQuery.ajax({
              type: 'POST',
              url: '/wp-admin/admin-ajax.php',
              data: JSON.stringify(fd),
              contentType: false,
              processData: false,
              dataType: 'json',
              success: function(response){
                jQuery('#messageform').show();

                jQuery('#invalid').hide();
                jQuery('#valid').show();
              }
            });
          }
          else {
            jQuery('#messageform').show();

            jQuery('#valid').hide();
            jQuery('#invalid').show();
          }
        });
      }
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
